import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { useForm } from 'react-hook-form'
import classnames from 'classnames'
import dispatchSelector from 'reduxModules/discountCode/dispatchers'
import stateSelector from 'reduxModules/discountCode/selectors'

import InlineError, { ariaErrorProps } from '../generic/InlineError'
import '../generic/RenderedField/styles.css'
import './styles.css'

export function DiscountCode({
  showDiscountCodeForm = false,
  validatedDiscountCode = {},
  className,
  onSubmit,
  toggleDiscountCode
}) {
  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors }
  } = useForm()

  return (
    <div
      id="DiscountCode"
      className={classnames({
        showForm: showDiscountCodeForm && !validatedDiscountCode.codename,
        [className]: className !== undefined
      })}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={classnames('field', '-floating', { '-error': errors.code })}>
          <div className="field-container">
            <input
              {...register('code', { required: 'Code is required' })}
              type="text"
              placeholder=" "
              id="discount-code-input"
              {...ariaErrorProps('discount-code-input', errors.code)}
            />
            <label htmlFor="discount-code-input">Discount Code</label>
            <InlineError
              id="discount-code-input"
              message={errors.code?.message}
            />
          </div>
        </div>
        <div className="actions">
          <span
            className="cta"
            onClick={() => toggleDiscountCode()}
            onKeyDown={(e) => e.key === 'Enter' && toggleDiscountCode()}
            role="button"
            tabIndex={0}
          >
            Close
          </span>
          <button
            type="submit"
            className="btn -small -thin -blue-2"
            disabled={isSubmitting}
          >
            Apply
          </button>
        </div>
      </form>
    </div>
  )
}

DiscountCode.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  toggleDiscountCode: PropTypes.func.isRequired,
  showDiscountCodeForm: PropTypes.bool,
  className: PropTypes.string,
  validatedDiscountCode: PropTypes.shape({
    codename: PropTypes.string
  })
}

export default connect(stateSelector, dispatchSelector)(DiscountCode)
